import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "112",
  height: "112",
  viewBox: "0 0 112 112",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M112 0H0V112H112V0Z",
      fill: "#D7DBF7"
    }, null, -1),
    _createElementVNode("path", {
      d: "M51.3334 37.3333H23.3334C20.7561 37.3333 18.6667 39.4227 18.6667 42V70C18.6667 72.5773 20.7561 74.6666 23.3334 74.6666H51.3334C53.9107 74.6666 56.0001 72.5773 56.0001 70V42C56.0001 39.4227 53.9107 37.3333 51.3334 37.3333Z",
      fill: "#151F6D"
    }, null, -1),
    _createElementVNode("path", {
      d: "M88.6666 37.3333H69.9999C67.4226 37.3333 65.3333 39.4227 65.3333 42V46.6666C65.3333 49.244 67.4226 51.3333 69.9999 51.3333H88.6666C91.2439 51.3333 93.3333 49.244 93.3333 46.6666V42C93.3333 39.4227 91.2439 37.3333 88.6666 37.3333Z",
      fill: "#959FEB"
    }, null, -1),
    _createElementVNode("path", {
      d: "M88.6666 60.6667H69.9999C67.4226 60.6667 65.3333 62.756 65.3333 65.3334V70C65.3333 72.5773 67.4226 74.6667 69.9999 74.6667H88.6666C91.2439 74.6667 93.3333 72.5773 93.3333 70V65.3334C93.3333 62.756 91.2439 60.6667 88.6666 60.6667Z",
      fill: "#959FEB"
    }, null, -1)
  ])))
}
export default { render: render }